// extracted by mini-css-extract-plugin
export default {"l_PhotoList_main":"PhotoList_l_PhotoList_main__2ZV9M","l_PhotoList_cardList":"PhotoList_l_PhotoList_cardList__+mES4","l_PhotoList_cardItem":"PhotoList_l_PhotoList_cardItem__BDNqU"};